import { http } from "@/apis/config/http";
import {
  imagingMetricsDashboardResponseSchema,
  type ImagingMetricsDashboardData,
  type ImagingMetricsDashboardParams,
} from "@/features/reports/schemas/reports";

/**
 * Obtiene métricas agregadas de imagenología para el reporte de negocio.
 * Endpoint: GET /api/v1/imaging/metrics/dashboard
 *
 * @param params - user_id + rango date_from/date_to (YYYY-MM-DD local)
 * @returns Datos del dashboard (estudios, por modalidad, buckets, growth)
 */
export async function getImagingMetricsDashboard(
  params: ImagingMetricsDashboardParams
): Promise<ImagingMetricsDashboardData> {
  const response = await http.get<unknown>("/api/v1/imaging/metrics/dashboard", {
    user_id: params.user_id,
    date_from: params.date_from,
    date_to: params.date_to,
  });

  const parsed = imagingMetricsDashboardResponseSchema.safeParse(response);
  if (!parsed.success) {
    throw new Error("Respuesta inválida del dashboard de métricas de imagenología");
  }

  return parsed.data.data;
}
